import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { IPMahakData } from '../../models';
import { ApiClientService } from '../../../../../../@core/services';


@Component({
  selector: 'renew-achievement-mahak',
  templateUrl: './renew-achievement-mahak.component.html',
  styleUrls: ['./renew-achievement-mahak.component.scss'],
})
export class RenewAchievementMahakComponent implements OnInit {
  unitId: number = 0;
  criteriaId: number = 0;
  data: IPMahakData;
  dataLoaded: boolean = false;

  constructor(private api: ApiClientService, private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.params.forEach((params: Params) => {
      this.unitId = +params['unitId'];
      this.criteriaId = +params['criteriaId'];
      this.getData();
    });
  }
  getData() {
    this.api.getData(`api/ImprovementPlan/Process/${this.unitId}/${this.criteriaId}`).subscribe((res: IPMahakData) => {
      this.data = res;
      this.dataLoaded = true;
      // console.log(res);
    });
  }
}
